import React from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';

//Componentes
import TableContainer from '../../components/table/TableContainer';

//Estilos
import './ManagersList.css';

function ManagersList({ functions, states }) {
    const { tableData, myManagersList } = states;

    return (
        <div className="managers_list-container">
            {myManagersList.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h3>No tiene usuarios encargados creados</h3>
            )}
            <div className="managers_list-footer">
                <Link to={RoutesApp.Managers.single + 0}>
                    <button className="btn btn-primary">
                        Agregar Encargado
                    </button>
                </Link>
            </div>
        </div>
    );
}

export default ManagersList;
